import { Award } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DOCTORS } from "../../data/doctors";

export const Doctors = () => {
    const { t } = useTranslation();

    return (
        <section
            id="doctors"
            data-testid="doctors-section"
            className="relative py-20 md:py-28"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
                    <div>
                        <div className="text-xs uppercase tracking-[0.2em] text-orange-600 font-semibold mb-3">
                            {t("doctors.eyebrow")}
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-stone-900 max-w-2xl leading-[1.05]">
                            {t("doctors.title")}
                        </h2>
                    </div>
                    <a
                        href="#enquiry"
                        data-testid="doctors-cta"
                        className="text-sm font-semibold text-brand-700 hover:text-brand-900 underline underline-offset-4"
                    >
                        {t("doctors.cta")}
                    </a>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
                    {DOCTORS.map((d) => {
                        const years = parseInt(d.experience, 10) || 0;
                        return (
                            <Link
                                key={d.slug}
                                to={`/doctors/${d.slug}`}
                                data-testid={`doctor-card-${d.slug}`}
                                className="group rounded-3xl bg-white border border-stone-200 overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all flex flex-col"
                            >
                                <div className="relative aspect-[4/5] overflow-hidden bg-stone-100">
                                    <img
                                        src={d.image}
                                        alt={d.name}
                                        className="absolute inset-0 h-full w-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                                    />
                                    <div className="absolute top-4 start-4 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white/95 text-stone-900 text-[11px] font-semibold">
                                        <Award className="h-3.5 w-3.5 text-amber-600" />
                                        {t("doctors.badge")}
                                    </div>
                                </div>
                                <div className="p-5 flex-1 flex flex-col">
                                    <div className="text-[11px] uppercase tracking-wider text-brand-700 font-semibold mb-1">
                                        {d.specialtyLabel}
                                    </div>
                                    <h3 className="font-display text-lg font-bold text-stone-900 leading-tight group-hover:text-brand-700 transition-colors">
                                        {d.name}
                                    </h3>
                                    <div className="mt-2 text-sm text-stone-600">
                                        {years > 0
                                            ? t("doctors.experience", { years })
                                            : d.experience}
                                    </div>
                                    <div className="text-xs text-stone-500 mt-0.5">
                                        {d.hospital}
                                    </div>
                                    <div className="mt-3 text-xs font-semibold text-brand-700 inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                                        View Profile →
                                    </div>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
